<template>
  <div class="font-sans">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
    setup() {
        const route = useRoute()

        const layout = computed(() => {
            // Default to 'default-layout' if no layout is specified in route meta
            return `${route.meta.layout || 'default'}-layout`
        })

        return {
            layout
        }
    }
})
</script>
